import React from 'react';
import { Link } from "react-router-dom";

import './outstation.css';

function OutstationTour() {
  return (
    <section className="outstation-tour" aria-labelledby="outstation-tour-heading">
      <div className="outstation-container">
        {/* Hero Section */}
        <div className="outstation-hero">
          <div className="outstation-hero-content">
            <h1 id="outstation-tour-heading" className="outstation-hero-title">
              Outstation Tours & Long Distance Travel
            </h1>
            <p className="outstation-hero-description">
              Discover breathtaking destinations with our premium outstation tour services. 
              Comfortable long-distance travel, experienced drivers, and memorable journeys await you.
            </p>
            <div className="outstation-hero-buttons">
              
                 <Link to="/bookings">
              <button className="outstation-cta-button primary">Book Outstation Tour</button></Link>
        
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number-outstation">500+</div>
                <div className="stat-label">Tours Completed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number-outstation">50+</div>
                <div className="stat-label">Destinations</div>
              </div>
              <div className="stat-item">
                <div className="stat-number-outstation">98%</div>
                <div className="stat-label">Happy Customers</div>
              </div>
            </div>
          </div>
          <div className="outstation-hero-image">
            <img 
              src="/outstation retionz.png" 
              alt="Comfortable outstation tour vehicle for long distance travel and scenic journeys"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Popular Destinations */}
        <div className="destinations-section">
          <h2 className="section-title">Popular Outstation Destinations</h2>
          <div className="destinations-grid">
            <div className="destination-card">
              <div className="destination-image">
                <img 
                  src="/laggala.webp" 
                  alt="Scenic hill station with beautiful mountain views"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <div className="destination-overlay">
                  <span className="distance">250 km</span>
                  <span className="duration">01 Day</span>
                </div>
              </div>
              <div className="destination-content">
                <h3>Mountain Retreat</h3>
                <p>Beautiful hill station with panoramic views and pleasant climate</p>
                <div className="destination-features">
                  <span> Scenic</span>
                  <span> 18°C</span>
                  <span> 4.8</span>
                </div>
                <div className="destination-price">
                  <span className="price">$199</span>
                  <span className="period">per trip</span>
                </div>
                 <Link to="/bookings">
                <button className="destination-book-btn">Book This Trip</button></Link>
              </div>
            </div>

            <div className="destination-card featured">
              <div className="popular-badge">Most Booked</div>
              <div className="destination-image">
                <img 
                  src="/aru.jpg" 
                  alt="Beautiful beach destination with golden sands"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <div className="destination-overlay">
                  <span className="distance">180 km</span>
                  <span className="duration">01 Day</span>
                </div>
              </div>
              <div className="destination-content">
                <h3>Beach Paradise</h3>
                <p>Golden sandy beaches with crystal clear waters and water sports</p>
                <div className="destination-features">
                  <span> Beach</span>
                  <span> 28°C</span>
                  <span> 4.9</span>
                </div>
                <div className="destination-price">
                  <span className="price">$169</span>
                  <span className="period">per trip</span>
                </div>
                <Link to="/bookings">
                <button className="destination-book-btn">Book This Trip</button></Link>
              </div>
            </div>

            <div className="destination-card">
              <div className="destination-image">
                <img 
                  src="/kandy.jpg" 
                  alt="Historical city with ancient architecture"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <div className="destination-overlay">
                  <span className="distance">300 km</span>
                  <span className="duration">01 Day</span>
                </div>
              </div>
              <div className="destination-content">
                <h3>Heritage City</h3>
                <p>Explore ancient architecture and rich cultural heritage sites</p>
                <div className="destination-features">
                  <span> Heritage</span>
                  <span> 25°C</span>
                  <span> 4.7</span>
                </div>
                <div className="destination-price">
                  <span className="price">$229</span>
                  <span className="period">per trip</span>
                </div>
                <Link to="/bookings">
                <button className="destination-book-btn">Book This Trip</button></Link>
              </div>
            </div>
          </div>
        </div>

        {/* Package Types */}
        <div className="packages-section">
          <h2 className="section-title">Let's Plan a Outstation Tour!</h2>

          <div className="packages-content">
            <div className="package-details">
              <h3>Perfect for quick getaways and short trips to nearby destinations</h3>
             
              <ul className="package-features">
                <li>✓ Up to 300 km round trip</li>
                <li>✓ 12 hours service included</li>
                <li>✓ Driver allowance covered</li>
                <li>✓ Toll & parking included</li>
                <li>✓ Live trip tracking</li>
                <li>✓ 24/7 support</li>
              </ul>

               <Link to="/bookings">
              <button className="package-book-btn">Book One Day Tour</button></Link>
            </div>
          </div>
        </div>



        {/* Service Features */}
        <div className="outstation-features-section">
          <h2 className="section-title">Why Choose Our Outstation Services</h2>
          <div className="outstation-features-grid">
            <div className="outstation-feature-card">
              <div className="feature-icon">1</div>
              <h3>Comfortable Travel</h3>
              <p>Spacious vehicles with comfortable seating for long journeys</p>
            </div>
            <div className="outstation-feature-card">
              <div className="feature-icon">2</div>
              <h3>Luggage Space</h3>
              <p>Ample luggage space for all your travel needs and shopping</p>
            </div>
            <div className="outstation-feature-card">
              <div className="feature-icon">3</div>
              <h3>Family Friendly</h3>
              <p>Perfect for family trips with child seat options available</p>
            </div>
            <div className="outstation-feature-card">
              <div className="feature-icon">4</div>
              <h3>Easy Booking</h3>
              <p>Simple online booking with instant confirmation</p>
            </div>
            <div className="outstation-feature-card">
              <div className="feature-icon">5</div>
              <h3>Flexible Payment</h3>
              <p>Multiple payment options including online and cash</p>
            </div>
            <div className="outstation-feature-card">
              <div className="feature-icon">6</div>
              <h3>Travel Insurance</h3>
              <p>Comprehensive travel insurance for complete peace of mind</p>
            </div>
          </div>
        </div>



        

        {/* CTA Section */}
        <div className="outstation-cta-section">
          <div className="cta-content">
            <h2>Ready for Your Next Adventure?</h2>
            <p>Book your outstation tour today and create unforgettable memories</p>
            <div className="cta-buttons">
              <Link to="/bookings">
              <button className="outstation-cta-button large primary">Book Now</button></Link>

  <a href="tel:+94701707707" className="contact-link">
              <button className="outstation-cta-button large secondary">Call for Custom Tour</button></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OutstationTour;